import SignupValidationAPI from '../../APIs/SignupAPI/SignupValidationAPI'

export const validateProvider = {
    state: {
        isProviderValid: ''
    },
    actions: {
        validateProvider({ commit }, signupCredentials) {
            SignupValidationAPI.signupProvider(signupCredentials).then((res) => {
                // Added modifier for dialog box yes if account exist or does not exist
                commit('VALIDATION_PROVIDER', {
                    STATUS: res.data.status,
                    STATE: res.data.state
                })
            }).catch((error) => {
                // Added modifier for dialog box yes if account exist or does not exist
                commit('VALIDATION_PROVIDER', {
                    STATUS: error.data.status,
                    STATE: error.data.state
                })
            })
        }
    },
    mutations: {
        VALIDATION_PROVIDER(state, isProviderValid) {
            state.isProviderValid = isProviderValid
        }
    },
    getters: {
        isPRoviderValid(state) {
            return state.isProviderValid
        }
    }
}
